import {
  EstimatedVisitCost as AWEstimatedVisitCost,
  Provider as AWProvider,
  ProviderDetails as AWProviderDetails
} from 'lib/amwell/sdk/types';
import { ProviderVisibility } from 'lib/amwell/sdk/enums';
import { Practice } from '../practices/types.web';

// Types
export type EstimatedVisitCost = AWEstimatedVisitCost;
export type Provider = AWProvider;
export type ProviderDetails = AWProviderDetails;

// Enums
export { ProviderVisibility };

// Action Types
export interface GetProvidersForPracticePayload {
  practice: Practice;
}

export interface GetProviderDetailPayload {
  provider: Provider;
}
